import { campaignRecipientSchema } from "@redotech/redo-marketing-common/campaigns/campaign-recipient-definition";
import { campaignRecipientColumnKeys } from "@redotech/redo-model/tables/campaign-recipients-list-sort";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCampaignRecipientsCount = {
  name: "getCampaignRecipientsCount" as const,
  input: z.object({ campaignId: z.string() }),
  output: z.object({ count: z.number() }),
};

export const paginateCampaignRecipients = {
  name: "paginateCampaignRecipients" as const,
  input: z.object({
    campaignId: z.string(),
    lastItem: z.optional(campaignRecipientSchema),
    sort: z.optional(
      z.object({
        direction: createEnum(SortDirection),
        key: createEnum(campaignRecipientColumnKeys),
      }),
    ),
    limit: z.number().optional(),
  }),
  output: z.object({ data: z.array(campaignRecipientSchema) }),
};
